import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["errorMessage", "paymentElement", "submitBtn"]
  static values = {
    stripePublicKey: String,
    clientSecret: String,
    locale: String,
    errorMessage: String
  }

  connect() {
    this.stripe = window.Stripe(this.stripePublicKeyValue)
    this.elements = this.stripe.elements({
      clientSecret: this.clientSecretValue,
      locale: this.localeValue
    })

    this.paymentElement = this.elements.create("payment")
    this.paymentElement.mount(this.paymentElementTarget)

    // Find the closest form element
    this.form = this.element.closest("form")
  }

  async handleSubmit(e) {
    e.preventDefault()
    this.submitBtnTarget.disabled = true

    const currentUrl = new URL(window.location.href)
    currentUrl.searchParams.delete("payment_intent")
    currentUrl.searchParams.delete("payment_intent_client_secret")
    currentUrl.searchParams.delete("redirect_status")

    try {
      const { error, paymentIntent } = await this.stripe.confirmPayment({
        elements: this.elements,
        confirmParams: {
          // eslint-disable-next-line camelcase
          return_url: currentUrl.toString(),
        },
        redirect: "if_required",
      })

      if (error) {
        this.errorMessageTarget.textContent = error.message
        this.submitBtnTarget.disabled = false
        return
      }

      if (paymentIntent.status === "requires_capture") {
        this.form.submit()
      } else {
        throw new Error(`${this.errorMessageValue} (Status: ${paymentIntent.status})`)
      }
    } catch (err) {
      this.errorMessageTarget.textContent = this.errorMessageValue
      this.submitBtnTarget.disabled = false
    }
  }
}
